'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadGoogleJs = function loadGoogleJs(id) {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0];
        var j = d.createElement(s);
        var dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', id);
};

exports.default = {
    init: function init(params) {
        if (!params) {
            return;
        }
        if (typeof params === 'string') {
            loadGoogleJs(params);
        } else {
            loadGoogleJs(params.id);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-f2e/statistics/dist/google/index.js
// module id = nv2h
// module chunks = 11